import api from '@/utils/api.js'

export default {
  namespaced: true,
  state: {
    csiList: undefined, // 缓存csi编号
    hardwarePlatform: undefined, // 缓存硬件平台
    language: undefined, // 缓存操作系统语言
    deploy: undefined, // 缓存操作系统语言
    urgency: undefined,
    severity: undefined,
  },
  getters: {
    getCsiList(state) {
      return state.csiList ?? []
    },
    getHardwarePlatform(state) {
      return state.hardwarePlatform ?? []
    },
    getLanguage(state) {
      return state.language ?? []
    },
    getDeploy(state) {
      return state.deploy ?? []
    },
    getUrgency(state) {
      return state.urgency ?? []
    },
    getSeverity(state) {
      return state.severity ?? []
    }
  },
  mutations: {
    setCsiList(state, payload) {
      state.csiList = payload
    },
    setHardwarePlatform(state, payload) {
      state.hardwarePlatform = payload
    },
    setLanguage(state, payload) {
      state.language = payload
    },
    setDeploy(state, payload) {
      state.deploy = payload
    },
    setUrgency(state, payload) {
      state.urgency = payload
    },
    setSeverity(state, payload) {
      state.severity = payload
    },
    clearCache(state) {
      for (const key in state) {
        state[key] = undefined
      }
    }
  },
  actions: {
    async getUrgency({commit, state, getters}) {
      try {
        // 优先使用已缓存的紧急字典；否则从后端字典接口拉取
        const result = state.urgency ?? (await api.base.dictDataList({dictType: 'order_urgency'})).records
        commit('setUrgency', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getSeverity({commit, state, getters}) {
      try {
        const result = state.severity ?? (await api.base.dictDataList({dictType: 'order_severity'})).records
        commit('setSeverity', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getCsiList({commit, state, getters}) {
      try {
        const result = state.csiList ?? (await api.tech.getOrderCsiListDto())
        commit('setCsiList', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getHardwarePlatformList({commit, state, getters}) {
      try {
        const result = state.hardwarePlatform ?? (await api.base.dictDataList({dictType: 'system_yingjian'})).records
        commit('setHardwarePlatform', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getLanguage({commit, state, getters}) {
      try {
        const result = state.language ?? (await api.base.dictDataList({dictType: 'system_yuyan'})).records
        commit('setLanguage', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDeploy({commit, state, getters}) {
      try {
        const result = state.deploy ?? (await api.base.dictDataList({dictType: 'system_arrange'})).records
        commit('setDeploy', result)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
  }
}
